angular.module("app").controller("EditPopupPageController", [
    '$scope',
    '$stateParams',
    '$uibModalInstance',
    '$timeout',
    '$filter',
    'pageStatuses',
    'popupsService',
    'logger',
    'errorHandler',
    'preloadedPopupData',
    'deepCompare',
    'settingsService',
    'preloadedNames',
    'preloadedTypes',
    'popupTypes',
    'countryCodes',
    'popupsShowOnPage',
    'newWindow',
    function ($scope, $stateParams, $modalInstance, $timeout, $filter, pageStatuses, popupsService, logger, errorHandler, preloadedPopupData, deepCompare, settingsService, preloadedNames, preloadedTypes, popupTypes, countryCodes, popupsShowOnPage, newWindow) {
        var init;
        var countryNameCodeMap = {};
        var countryCodeNameMap = {};
        $scope.countryCodes = countryCodes.map(function (item) {
            countryNameCodeMap[item.name] = item["alpha-2"];
            countryCodeNameMap[item["alpha-2"]] = item.name;
            return item.name;
        });
        $scope.preloadedTypes = angular.copy(preloadedTypes);
        $scope.actualPageNames = angular.copy(preloadedNames.names);
        $scope.popupTypes = angular.copy(popupTypes);
        $scope.pageStatuses = pageStatuses;
        $scope.newWindow = newWindow;
        $scope.settings = settingsService.getSettings();
        $scope.tooltip = {
            pageTitle: ""
        };
        $scope.show_on_page = angular.copy(popupsShowOnPage);
        $scope.showCustomRepeatError = {
            show: false
        };
        function extractUsedNames(response) {
            $scope.usedNameShowOnPage = {};
            $scope.usedShowOnPageName = {};
            $scope.actualPageNames.forEach(function (value) {
                $scope.usedNameShowOnPage[value.name] = {};
            });
            if (response.used) {
                Object.keys(response.used).forEach(function (value) {
                    $scope.usedShowOnPageName[value] = {};
                    response.used[value].forEach(function (item) {
                        $scope.usedShowOnPageName[value][item] = true;
                        $scope.usedNameShowOnPage[item][value] = true;
                    })
                });

                if ($scope.pageData.name === "") {
                    $scope.usedNameShowOnPage[""] = {};
                    $scope.show_on_page.forEach(function (value) {
                        if ($scope.usedShowOnPageName[value] && Object.keys($scope.usedShowOnPageName[value]).length === $scope.actualPageNames.length) {
                            $scope.usedNameShowOnPage[""][value] = true;
                        }
                    });
                }
                if ($scope.pageData.show_on_page === '') {
                    $scope.usedShowOnPageName[''] = {};
                    $scope.actualPageNames.forEach(function (value) {
                        if ($scope.usedNameShowOnPage[value] && Object.keys($scope.usedNameShowOnPage[value]).length === $scope.show_on_page.length) {
                            $scope.usedShowOnPageName[""][value] = true;

                        }
                    });
                }
            }

        }

        (init = function (data, doNotUpdatePicker) {
            if (!data){
                return;
            }
            $scope.pageData = angular.copy(data);
            if (!doNotUpdatePicker) {
                $scope.vm = {
                    dateTimeFrom:  $scope.pageData.start_date || "",
                    dateTimeTo:  $scope.pageData.end_date || ""
                };
            }
            $scope.initialName = $scope.pageData.name;
            $scope.initialShowOnPage = $scope.pageData.show_on_page;
            $scope.pageData.country = $scope.pageData.country.map(function (item) {
                return countryCodeNameMap[item];
            }) || [];
            extractUsedNames(preloadedNames);


        })(preloadedPopupData);

        $scope.submitEditPopupForm = function () {
            if (!$scope.edit_popup_form.$valid) {
                $scope.showCustomRepeatError.show = true;
                $scope.isSavePressed = true;
                return;
            } else if ($scope.getChanges()) {
                logger.logError("global.no_changes");
                return;
            }
            delete $scope.pageData.forceTOChange;
            var changes = deepCompare.getChanges(angular.copy(preloadedPopupData), $scope.pageData);
            var countries = $scope.pageData.country.map(function (item) {
               return countryNameCodeMap[item];
            });
            if (!angular.equals(preloadedPopupData.country, countries)) {
                changes = changes || {};
                changes.country = countries;
            } else {
                delete changes.country;
            }

            if (!!changes) {
                var requestObj = {
                    popup: angular.copy(changes)
                };
                requestObj.popup.id = $scope.pageData.id;
                (!!$scope.vm.fromDate || (!!preloadedPopupData.start_date && !$scope.vm.dateTimeFrom)) && (requestObj.popup.start_date = $scope.vm.fromDate || null);

                (!!$scope.vm.toDate || (!!preloadedPopupData.end_date && !$scope.vm.dateTimeTo)) && (requestObj.popup.end_date = $scope.vm.toDate || null);

                popupsService.update(requestObj).then(
                    function (response) {
                        if (response.status === "ok") {
                            updateScope();
                            $modalInstance.close();
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (error) {
                        errorHandler(error.message);
                    }
                )
            }
        };

        $scope.handleChangeOfSetToAllLanguagesBox = function (isEnabled) {
            if (!isEnabled) {
                $scope.pageData.lang = $scope.pageData.lang || $scope.settings.skin.defaultLang || $scope.settings.skin.languages[0];
            }
        };

        $scope.handleChangeOfDateTimePicker = function (dateTime, dateToSave) {
            if (this.from) {
                $scope.vm.dateTimeFrom = dateTime;
                $scope.vm.fromDate = dateToSave || undefined;
                $scope.pageData.start_date = $scope.vm.fromDate;
            } else {
                $scope.vm.dateTimeTo = dateTime;
                $scope.vm.toDate = dateToSave || undefined;
                $scope.pageData.end_date = $scope.vm.toDate;
            }

        };

        $scope.getChanges = function () {
            var pageData = angular.copy($scope.pageData);
            pageData.country = pageData.country.map(function (value) { return countryNameCodeMap[value]; })
            return deepCompare.isEqual(pageData, angular.copy(preloadedPopupData));
        };

        function updateScope () {
            popupsService.getPopupById().then(
                function (response) {
                    if (response.status === "ok") {
                        init(response.popup, true);
                        preloadedPopupData = angular.copy(response.popup);
                        logger.logSuccess("global.saved");
                        $scope.add_page_form && $scope.add_page_form.$setPristine && $scope.add_page_form.$setPristine();
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        }

        $scope.handleNameChange = function () {
            $timeout(function(){
                $("#showOnPageSelect").trigger('chosen:updated');
                $("#nameSelect").trigger('chosen:updated');
            },100);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
]);
